module.exports = "<vue-component component=\"TreeRegistryList\"></vue-component>\n"